<template>
  <div>
    <integrationNipModal
      ref="integrationNipModal"
      :defaultNip="defaultNip"
      @handlerNipClose="handlerNipClose"
    />
    <a-form
      id="my_form_styl"
      :label-col="{
        span: 12,
      }"
      :wrapper-col="{
        span: 12,
      }"
      :form="form"
    >
      <div
        style="text-align: center; font-weight: 700"
        v-show="document.invoiceAutoNumber"
      >
        {{ document.invoiceAutoNumber }} | {{ document.invoiceTitle }}
      </div>
      <a-form-item
        :label="$t('File name')"
        style="margin-top: 10px; border-top: 1px solid #d3d3d3"
      >
        <a-tooltip>
          <template slot="title">
            <span>{{ document.NAME }}</span>
          </template>
          <span>{{ document.NAME }}</span>
        </a-tooltip>
      </a-form-item>

      <a-form-item :label="$t('Status')">
        <a-tag style="font-weight: bold" :color="statusTag.color">{{
          $t(document.status)
        }}</a-tag>
      </a-form-item>

      <a-form-item>
        <a-tooltip
          slot="label"
          placement="top"
          :title="$t('ocr_field_tooltip')"
        >
          {{ $t("Main Company") }}
          <a-icon
            type="file-search"
            :style="{ color: OCRColorIcon.my_company }"
          />
        </a-tooltip>
        <template v-if="disableFromResponsible || !currentEdit">
          {{ getCompany(document.my_company) }}
        </template>
        <div v-else>
          <a-input
            @change="changePromptStatus"
            @click="handleChangeMyCompany()"
            :disabled="disableFromResponsible || !currentEdit"
            v-model="myCompanyTitle"
          />
        </div>
        <!--<a-select
          v-else
          showSearch
          allowClear
          optionFilterProp="children"
          v-decorator="[
            'my_company',
            {
              rules: [
                {
                  required: true,
                  message: $t('Main Company') + $t('required_field'),
                },
              ],
              initialValue: document.my_company,
            },
          ]"
        >
          <a-select-option v-for="(comp, id) in MY_COMPANY_LIST" :key="id"
            >{{ comp.TITLE }}
            {{
              comp[companyFieldForNIP] ? "/ " + comp[companyFieldForNIP] : ""
            }}</a-select-option
          >
        </a-select>-->
      </a-form-item>

      <a-form-item>
        <a-tooltip
          slot="label"
          placement="top"
          :title="$t('ocr_field_tooltip')"
        >
          {{ $t("Contractor") }}
          <a-icon
            type="file-search"
            :style="{ color: OCRColorIcon.kontragent }"
          />
        </a-tooltip>
        <template v-if="disableFromResponsible || !currentEdit">{{
          getCompany(document.kontragent)
        }}</template>
        <div v-else style="display: flex">
          <a-input
            @change="changePromptStatus"
            @click="handleChangeContractor()"
            :disabled="disableFromResponsible || !currentEdit"
            v-model="contactorTitle"
          />
          <!-- <a-select
            style="width: 91%"
            showSearch
            allowClear
            optionFilterProp="children"
            @change="handlerChangeContractor"
            v-decorator="[
              'kontragent',
              {
                rules: [
                  {
                    required: true,
                    message: $t('Contractor') + $t('required_field'),
                  },
                ],
                initialValue: document.kontragent,
              },
            ]"
          >
            <a-select-option v-for="(comp, id) in COMPANY_LIST" :key="id"
              >{{ comp.TITLE }}
              {{
                comp[companyFieldForNIP] ? "/ " + comp[companyFieldForNIP] : ""
              }}</a-select-option
            >
          </a-select>-->
          <a-button
            @click="$refs.integrationNipModal.showModal()"
            type="primary"
            icon="plus"
          />
        </div>
      </a-form-item>

      <a-form-item>
        <a-tooltip
          slot="label"
          placement="top"
          :title="$t('ocr_field_tooltip')"
        >
          {{ $t("Bank account") }}
          <a-icon
            type="file-search"
            :style="{ color: OCRColorIcon.bankAccount }"
          />
        </a-tooltip>
        <template v-if="disableFromResponsible || !currentEdit">{{
          document.bankAccount
        }}</template>
        <div v-else style="display: flex">
          <a-auto-complete
            style="width: 91%"
            :data-source="bankAccountList"
            :filter-option="filterOption"
            v-decorator="[
              'bankAccount',
              {
                rules: [{ required: false }],
                initialValue: document.bankAccount,
              },
            ]"
          />
          <a-button
            @click="addBankAccount"
            type="primary"
            icon="plus"
            :disabled="isBankAccountSaved"
          />
        </div>
      </a-form-item>
      <a-form-item>
        <a-tooltip
          slot="label"
          placement="top"
          :title="$t('ocr_field_tooltip')"
        >
          {{ $t("Invoice number") }}
          <a-icon
            type="file-search"
            :style="{ color: OCRColorIcon.num_invoice }"
          />
        </a-tooltip>
        <template v-if="disableFromResponsible || !currentEdit">{{
          document.num_doc
        }}</template>
        <a-auto-complete
          v-else
          :data-source="
            bounds.length != 0 &&
            Array.from(new Set(bounds.find((el) => el.label == 'whole').titles))
          "
          v-decorator="[
            'num_invoice',
            {
              rules: [
                {
                  required: false,
                  message: $t('Invoice number') + $t('required_field'),
                },
              ],
              initialValue: document.num_doc,
            },
          ]"
        />
      </a-form-item>
      <a-form-item :label="$t('Type')">
        <template v-if="disableFromResponsible || !currentEdit">
          {{ invoiceTypeSelect[document.invoiceType] }}</template
        >
        <a-select
          v-else
          @change="handlerInvoiceType"
          v-decorator="[
            'invoiceType',
            {
              rules: [{ required: false }],
              initialValue: document.invoiceType || 'Faktura Kosztowa',
            },
          ]"
        >
          <a-select-option key="Faktura Kosztowa">{{
            $t("Faktura Kosztowa")
          }}</a-select-option>
          <a-select-option key="Proforma">{{ $t("Proforma") }}</a-select-option>
          <a-select-option key="VAT Marza">{{
            $t("Faktura do Proformy")
          }}</a-select-option>
          <a-select-option key="Korygujaca">{{
            $t("Korygująca")
          }}</a-select-option>
          <a-select-option key="Faktura zaliczkowa">{{
            $t("Faktura zaliczkowa")
          }}</a-select-option>
          <a-select-option key="Faktura koncowa">{{
            $t("Faktura końcowa")
          }}</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item v-if="selectInvoiceCorrection">
        <template slot="label">
          <span v-if="selectInvoiceCorrection == 'Correction'">{{
            $t("Corrected document")
          }}</span>
          <span v-else-if="selectInvoiceCorrection == 'Prepayment'">{{
            $t("Prepayment document")
          }}</span>
          <span v-else-if="selectInvoiceCorrection == 'VatDiff'">{{
            $t("VAT Marża przedpłaty")
          }}</span>
        </template>
        <div style="display: flex">
          <a-select
            v-if="selectInvoiceCorrection == 'VatDiff'"
            showSearch
            optionFilterProp="children"
            v-decorator="[
              'invoiceCorrection',
              { rules: [{ required: false }] },
            ]"
          >
            <a-select-option
              v-for="(itm, index) in invoiceCorrectionVaribl"
              :key="index"
              >{{ itm.NAME }}</a-select-option
            >
          </a-select>
          <a-select
            v-else
            howSearch
            optionFilterProp="children"
            @change="handlerInvoiceCorrection"
            v-decorator="[
              'invoiceCorrection',
              { rules: [{ required: false }] },
            ]"
          >
            <a-select-option
              v-for="(itm, index) in invoiceCorrectionVaribl"
              :key="index"
              >{{ itm.num_doc }}</a-select-option
            >
          </a-select>
          <a-button @click="preview" type="primary" icon="eye" />
        </div>
      </a-form-item>

      <a-form-item>
        <a-tooltip
          slot="label"
          placement="top"
          :title="$t('ocr_field_tooltip')"
        >
          {{ $t("Payment") }}
          <a-icon
            type="file-search"
            :style="{ color: OCRColorIcon.paymentType }"
          />
        </a-tooltip>
        <template v-if="disableFromResponsible || !currentEdit">{{
          document.payment && document.payment.type
        }}</template>
        <a-select
          v-else
          v-decorator="[
            'paymentType',
            {
              rules: [{ required: false }],
              initialValue: document.payment
                ? document.payment.type
                : 'Przelew',
            },
          ]"
        >
          <a-select-option key="Gotówka">{{ $t("Gotówka") }}</a-select-option>
          <a-select-option key="Przelew">{{ $t("Przelew") }}</a-select-option>
          <a-select-option key="Karta">{{ $t("Karta") }}</a-select-option>
          <a-select-option key="Pobranie">{{ $t("Pobranie") }}</a-select-option>
          <a-select-option key="Kompensata">{{
            $t("Kompensata")
          }}</a-select-option>
          <a-select-option key="Barter">{{ $t("Barter") }}</a-select-option>
          <a-select-option key="Płatność przez Pracownika">{{ $t("Płatność przez Pracownika") }}</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item>
        <a-tooltip
          slot="label"
          placement="top"
          :title="$t('ocr_field_tooltip')"
        >
          {{ $t("Currency")
          }}{{
            currencyDate && form.getFieldValue("currencyCode") != "PLN"
              ? ` (${currencyDate})`
              : ""
          }}
          <a-icon
            type="file-search"
            :style="{ color: OCRColorIcon.currencyCode }"
          />
        </a-tooltip>
        <template v-if="disableFromResponsible || !currentEdit"
          >{{
            document.currency
              ? document.currency.code
              : info.currency[0]["CURRENCY"]
          }}
          <a-divider type="vertical" style="background: #d3d3d3" />
          {{
            document.currency
              ? document.currency.val
              : info.currency[0]["AMOUNT"]
          }}
        </template>
        <template v-else>
          <a-col :span="11">
            <a-select
              @change="(e) => handleCurrencyCodeChange(e, 'currency')"
              v-decorator="[
                'currencyCode',
                {
                  rules: [{ required: false }],
                  initialValue: document.currency
                    ? document.currency.code
                    : info.currency[0]['CURRENCY'],
                },
              ]"
            >
              <a-select-option
                v-for="item in info.currency"
                :key="item.CURRENCY"
                >{{ item.CURRENCY }}</a-select-option
              >
            </a-select>
          </a-col>
          <a-col :span="11" offset="2">
            <a-input
              v-decorator="[
                'currencyVal',
                {
                  rules: [{ required: false }],
                  initialValue: document.currency
                    ? document.currency.val
                    : info.currency[0]['AMOUNT'],
                },
              ]"
            />
          </a-col>
        </template>
      </a-form-item>

      <a-form-item :label="$t('Keywords')">
        <template v-if="disableFromResponsible || !currentEdit">
          <a-tag
            v-for="(item, key) in document.key_words"
            color="green"
            :key="key"
            >{{ item }}</a-tag
          >
        </template>
        <a-select
          v-else
          mode="multiple"
          v-decorator="[
            'key_words',
            {
              rules: [{ required: false }],
              initialValue: document.key_words || [],
            },
          ]"
        >
          <a-select-option v-for="i in key_words" :key="i">{{
            i
          }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :label="$t('Tag')">
        <template v-if="disableFromResponsible || !currentEdit">
          <a-tag
            v-for="(item, key) in document.Teczka"
            color="blue"
            :key="key"
            >{{ item }}</a-tag
          >
        </template>
        <a-select
          v-else
          :dropdownMatchSelectWidth="false"
          mode="tags"
          v-decorator="[
            'Teczka',
            { rules: [{ required: false }], initialValue: document.Teczka },
          ]"
        >
          <a-select-option v-for="i in info.teczkalist" :key="i">{{
            i
          }}</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item>
        <a-tooltip
          slot="label"
          placement="top"
          :title="$t('Assistant from the company card')"
        >
          {{ $t("Owner") }}
          <a-icon type="question-circle-o" />
        </a-tooltip>
        <template>{{ getCompanyAssign(document.my_company) }}</template>
      </a-form-item>

      <a-form-item style="margin-top: 50px; border-top: 1px solid #d3d3d3">
        <a-tooltip
          slot="label"
          placement="top"
          :title="$t('ocr_field_tooltip')"
        >
          {{ $t("Date of receiving") }}
          <a-icon
            type="file-search"
            :style="{ color: OCRColorIcon.date_send }"
          />
        </a-tooltip>
        <template v-if="disableFromResponsible || !currentEdit">
          {{ document.date_send }}
          >
        </template>
        <a-date-picker
          v-else
          style="width: 100%"
          v-decorator="[
            'date_send',
            {
              rules: [
                {
                  required: true,
                  message: $t('Date of receiving') + $t('required_field'),
                },
              ],
              initialValue: document.date_send
                ? moment(document.date_send, 'YYYY-MM-DD')
                : '',
            },
          ]"
        />
      </a-form-item>
      <a-form-item>
        <a-tooltip
          slot="label"
          placement="top"
          :title="$t('ocr_field_tooltip')"
        >
          {{ $t("Date of issue") }}
          <a-icon
            type="file-search"
            :style="{ color: OCRColorIcon.date_recept }"
          />
        </a-tooltip>
        <template v-if="disableFromResponsible || !currentEdit">
          {{ document.date_recept }}
        </template>
        <a-date-picker
          v-else
          :format="YYYY - MM - DD"
          style="width: 100%"
          v-decorator="[
            'date_recept',
            {
              rules: [
                {
                  required: true,
                  message: $t('Date of issue') + $t('required_field'),
                },
              ],
              initialValue: document.date_recept
                ? moment(document.date_recept, 'YYYY-MM-DD')
                : '',
            },
          ]"
        />
      </a-form-item>

      <a-form-item>
        <a-tooltip
          slot="label"
          placement="top"
          :title="$t('ocr_field_tooltip')"
        >
          {{ $t("Sale date") }}
          <a-icon
            type="file-search"
            :style="{ color: OCRColorIcon.saleDate }"
          />
        </a-tooltip>
        <template v-if="disableFromResponsible || !currentEdit">
          {{ document.saleDate }}
        </template>
        <a-date-picker
          v-else
          style="width: 100%"
          :format="YYYY - MM - DD"
          @change="(e) => handleDateChange(e, 'currency')"
          v-decorator="[
            'saleDate',
            {
              rules: [
                {
                  required: true,
                  message: $t('Sale date') + $t('required_field'),
                },
              ],
              initialValue: document.saleDate
                ? moment(document.saleDate, 'YYYY-MM-DD')
                : '',
            },
          ]"
        />
      </a-form-item>

      <a-form-item>
        <a-tooltip
          slot="label"
          placement="top"
          :title="$t('ocr_field_tooltip')"
        >
          {{ $t("Date of payment") }}
          <a-icon
            type="file-search"
            :style="{ color: OCRColorIcon.paymentDate }"
          />
        </a-tooltip>
        <template v-if="disableFromResponsible || !currentEdit">
          {{ document.paymentDate }}
        </template>
        <a-date-picker
          v-else
          style="width: 100%"
          :format="YYYY - MM - DD"
          v-decorator="[
            'paymentDate',
            {
              rules: [
                {
                  required: true,
                  message: $t('Date of payment') + $t('required_field'),
                },
              ],
              initialValue: document.paymentDate
                ? moment(document.paymentDate, 'YYYY-MM-DD')
                : '',
            },
          ]"
        />
      </a-form-item>

      <a-form-item :label="$t('Planned date')">
        <template v-if="disableFromResponsible || !currentEdit">
          {{ document.plannedDate }}
        </template>
        <a-date-picker
          v-else
          style="width: 100%"
          :format="YYYY - MM - DD"
          v-decorator="[
            'plannedDate',
            {
              rules: [{ required: false }],
              initialValue: document.plannedDate
                ? moment(document.plannedDate, 'YYYY-MM-DD')
                : '',
            },
          ]"
        />
      </a-form-item>
      <a-form-item :label="$t('Reminder')">
        <template v-if="disableFromResponsible || !currentEdit">
          {{ document.reminderDate }}
        </template>
        <a-date-picker
          v-else
          style="width: 100%"
          :format="YYYY - MM - DD"
          v-decorator="[
            'reminderDate',
            {
              rules: [{ required: false }],
              initialValue: document.reminderDate
                ? moment(document.reminderDate, 'YYYY-MM-DD')
                : '',
            },
          ]"
        />
      </a-form-item>

      <a-divider style="margin-top: 50px; margin-bottom: 0px">
        {{ $t("Zapłata") }}
      </a-divider>

      <a-form-item
        :label="$t('Date of booking')"
        has-feedback
        :validate-status="validatePaymentDateReal"
      >
        <a-date-picker
          :format="YYYY - MM - DD"
          :disabled="disableFromResponsible || !currentEdit"
          @change="handlerChangePaymentDateReal"
          v-decorator="[
            'PaymentDateReal',
            { rules: [{ required: false }], initialValue: moment() },
          ]"
        />
      </a-form-item>

      <a-form-item>
        <span slot="label">
          {{ $t("Kwota") }}
          <span>
            <a-tag color="cyan">{{ kwotaVals.paidPercent }}%</a-tag>
            <a-tag color="green">{{ kwotaVals.paidSum }}</a-tag>
          </span>
        </span>
        <div style="display: flex">
          <a-input-number
            style="flex: 1"
            :disabled="disableFromResponsible || !currentEdit"
            :min="0"
            :max="kwotaVals.leftToPay"
            v-decorator="[
              'kwotaVal',
              { rules: [{ required: false }], initialValue: 0 },
            ]"
          />
          <a-button-group style="margin-left: 10px">
            <a-button
              type="primary"
              icon="plus"
              :disabled="disableFromResponsible || !currentEdit"
              @click="() => handlerKwotaAdd()"
            />
            <a-button
              type="primary"
              icon="history"
              @click="kwotaHistoryVisible = !kwotaHistoryVisible"
            />
          </a-button-group>
        </div>
      </a-form-item>

      <a-timeline style="padding: 15px 0 0 25px" v-show="kwotaHistoryVisible">
        <a-timeline-item
          v-for="(item, index) in kwotaVals.history"
          :key="index"
        >
          <a-row type="flex" justify="space-around" align="middle">
            <a-col :span="4">
              {{ item.date }}
            </a-col>
            <a-col :span="4">
              {{ item.payment }}
            </a-col>
            <a-col :span="4">
              {{
                USER_LIST[item.user].NAME + " " + USER_LIST[item.user].LAST_NAME
              }}
            </a-col>
            <a-col :span="4">
              <a-button
                type="link"
                icon="delete"
                style="color: #ff4d4f"
                v-if="profile.ADMIN || profile.ID == item.user"
                @click="() => handlerKwotaDelete(index)"
              />
            </a-col>
          </a-row>
        </a-timeline-item>
      </a-timeline>

      <template v-if="document.Quota">
        <a-form-item
          :label="$t('Kwota Netto')"
          style="
            margin-top: 50px;
            border-top: 1px solid #d3d3d3;
            background-color: #e6f7ff;
          "
        >
          <a-statistic :precision="2" :value="document.Quota.Netto" />
        </a-form-item>
        <a-form-item :label="$t('Kwota Vat')" style="background-color: #e6f7ff">
          <a-statistic :precision="2" :value="document.Quota.Vat" />
        </a-form-item>
        <a-form-item
          :label="$t('Kwota Brutto')"
          style="background-color: #e6f7ff"
        >
          <a-statistic :precision="2" :value="document.Quota.Bruto" />
        </a-form-item>
      </template>
    </a-form>
  </div>
</template>

<script>
import moment from "moment";
import { requestStep, getCurrency, getInvoiceCorrection } from "@/requestFunc";
import integrationNipModal from "@/components/integrationNipModal";
import {
  suggestPaymentDate,
  suggestSaleDate,
  suggestDateRecept,
  suggestDateSend,
  suggestCurrency,
  suggestPaymentType,
  suggestBankAccount,
  suggestNips,
  suggestInvoiceId,
} from "@/OCR";
import { mapGetters } from "vuex";
export default {
  components: {
    integrationNipModal,
  },
  props: [
    "document",
    "bounds",
    "table",
    "statusTag",
    "MY_COMPANY_LIST",
    "COMPANY_LIST",
    "USER_LIST",
    "info",
    "disableFromResponsible",
    "key_words",
    "responsible",
    "profile",
    "commentsData",
    "currentEdit",
    "user_setup",
  ],
  computed: { ...mapGetters(["companyFieldForNIP"]) },
  data() {
    return {
      form: this.$form.createForm(this, { name: "form_1" }),
      selectInvoiceCorrection: "",
      invoiceCorrectionVaribl: [],
      validatePaymentDateReal: "success",
      bankAccountList: [],
      defaultNip: "",
      myCompany: "",
      contractor: "",
      myCompanyTitle: "",
      contactorTitle: "",
      OCRColorIcon: {
        my_company: "initial",
        bankAccount: "initial",
        kontragent: "initial",
        paymentDate: "initial",
        date_recept: "initial",
        num_invoice: "initial",
        saleDate: "initial",
        date_send: "initial",
        currencyCode: "initial",
        paymentType: "initial",
      },
      isBankAccountSaved: false,
      kwotaHistoryVisible: false,
      kwotaVals: {},
      invoiceTypeSelect: {
        "Faktura Kosztowa": this.$t("Faktura Kosztowa"),
        Proforma: this.$t("Proforma"),
        "VAT Marza": this.$t("Faktura do Proformy"),
        Korygujaca: this.$t("Korygująca"),
        "Faktura zaliczkowa": this.$t("Faktura zaliczkowa"),
        "Faktura koncowa": this.$t("Faktura końcowa"),
      },
    };
  },
  watch: {
    bounds: function () {
      // let dates = this.bounds.filter((el) => el.label == "labeled_date");
      let whole = this.bounds[this.bounds.length - 1].text;
      let suggests = {
        nips: suggestNips(whole),
        bankAccount: suggestBankAccount(whole),
        paymentType: suggestPaymentType(whole),
        currencyCode: suggestCurrency(whole),
        date_send: suggestDateSend(whole),
        date_recept: suggestDateRecept(whole),
        saleDate: suggestSaleDate(whole),
        paymentDate: suggestPaymentDate(whole),
        num_invoice: suggestInvoiceId(whole),
      };
      this.boundsNips(suggests.nips);
      this.boundsCheck(suggests.bankAccount[0], "bankAccount");
      this.isBankAccountSaved = this.bankAccountList.includes(
        suggests.bankAccount[0]
      );
      this.boundsCheck(suggests.paymentType, "paymentType");
      this.boundsCheck(suggests.currencyCode, "currencyCode");
      if (suggests.currencyCode)
        this.handleCurrencyCodeChange(suggests.currencyCode, "currency");
      this.boundsCheck(suggests.date_send, "date_send");
      this.boundsCheck(suggests.date_recept, "date_recept");
      this.boundsCheck(suggests.saleDate, "saleDate");
      if (suggests.saleDate)
        this.handleDateChange(suggests.saleDate, "currency");
      this.boundsCheck(suggests.paymentDate, "paymentDate");
      if (suggests.num_invoice) {
        this.boundsCheck(suggests.num_invoice, "num_invoice");
      } else {
        let kk = this.bounds.filter((el) => el.label == "id");
        if (kk.length) this.suggestInvoiceId(kk);
        else this.OCRColorIcon.num_invoice = "red";
      }
    },
  },
  methods: {
    moment,
    getCompany(id) {
      let company = this.document.arrayCompany.find((x) => x.ID == id);
      return company ? company.TITLE : "";
    },
    getCompanyAssign(id) {
      let company = this.document.arrayCompany.find((x) => x.ID == id);

      if(!company){
      return ""
      }

      let user = this.document.userList.find(
        (x) => x.ID == company.ASSIGNED_BY_ID
      );

      let name = user ? user.NAME + " " + user.LAST_NAME : "";
      return name;
    },
    handleChangeMyCompany() {
      // eslint-disable-next-line
      BX24.selectCRM(
        {
          entityType: ["company"],
          multiple: false,
        },
        (info) => {
          this.myCompany = info.company[0].id.split("_")[1];
          this.myCompanyTitle = info.company[0].title;
        }
      );
    },
    handleChangeContractor() {
      // eslint-disable-next-line
      BX24.selectCRM(
        {
          entityType: ["company"],
          multiple: false,
        },
        (info) => {
          this.contractor = info.company[0].id.split("_")[1];
          this.contactorTitle = info.company[0].title;
        }
      );
    },
    findSimilarNIP(searchNIP, allNips) {
      for (let start = 0, end = 5; end < searchNIP.length; start++, end++) {
        let search = searchNIP.slice(start, end);
        let findNIP = allNips.find((x) => x.indexOf(search, start) != -1);
        if (findNIP) return findNIP;
      }
      return "";
    },
    boundsNips(nips) {
      var main = false;
      var contractor = false;
      if (nips.extra) {
        if (nips.extra.main)
          main = this.document.arrayCompany.find(
            (x) => x[this.companyFieldForNIP] == nips.extra.main
          );
        if (nips.extra.contractor)
          contractor = this.document.arrayCompany.find(
            (x) => x[this.companyFieldForNIP] == nips.extra.contractor
          );
      } else {
        if (Array.isArray(this.info.my_company)) {
          main = this.info.my_company.find((el) =>
            nips.nips.includes(el[this.companyFieldForNIP])
          );
        }

        //FIXME Брать тип фирмы из настроек и по id из crm_status_list
        if (Array.isArray(this.info.company)) {
          contractor = this.info.company.find(
            (el) =>
              el.COMPANY_TYPE != "PARTNER" &&
              nips.nips.includes(el[this.companyFieldForNIP])
          );
        }
      }
      //FIXME если нашел один нип то второй убирать из массива!!!!!!!
      // if (!main) {
      //   let allNips = this.info.my_company
      //     .map((x) => x[this.companyFieldForNIP])
      //     .filter(Boolean);
      //   let result = [];
      //   for (let i of nips.nips) {
      //     let res = this.findSimilarNIP(i, allNips);
      //     if (res && !result.includes(res)) result.push(res);
      //   }
      //   if (result.length) {
      //     main = this.info.my_company.find((el) =>
      //       result.includes(el[this.companyFieldForNIP])
      //     );
      //   }
      // }
      // if (!contractor) {
      //   let allNips = this.info.company
      //     .filter((x) => x.COMPANY_TYPE != "PARTNER")
      //     .map((x) => x[this.companyFieldForNIP])
      //     .filter(Boolean);
      //   let result = [];
      //   for (let i of nips.nips) {
      //     let res = this.findSimilarNIP(i, allNips);
      //     if (res && !result.includes(res)) result.push(res);
      //   }
      //   if (result.length) {
      //     contractor = this.info.company.find(
      //       (el) =>
      //         result.includes(el[this.companyFieldForNIP]) &&
      //         el.COMPANY_TYPE != "PARTNER"
      //     );
      //   }
      // }

      this.boundsCheck(main && main.ID, "my_company");
      if (contractor) {
        this.boundsCheck(contractor.ID, "kontragent");
        this.handlerChangeContractor(contractor.ID);
      } else {
        if (nips.extra.contractor) this.defaultNip = nips.extra.contractor;
        else if (main && nips.nips.length > 1)
          this.defaultNip = nips.nips.find(
            (x) => x != main[this.companyFieldForNIP]
          );
        this.OCRColorIcon["kontragent"] = this.defaultNip ? "green" : "red";
      }
    },
    handlerNipClose(companyID) {
      if (companyID) {
        if (this.COMPANY_LIST[companyID]) {
          this.form.setFieldsValue({
            kontragent: companyID.toString(),
          });
        } else {
          BX24.callMethod("crm.company.get", { id: companyID }, (result) => {
            if (result.error()) console.error(result.error());
            else {
              let companyInfo = result.data();
              this.COMPANY_LIST = Object.assign({}, this.COMPANY_LIST, {
                [companyID]: companyInfo,
              });
              this.form.setFieldsValue({
                kontragent: companyInfo.ID,
              });
            }
          });
        }
      }
    },
    boundsCheck(result, key) {
      if (result) {
        if (!this.form.getFieldValue(key))
          this.form.setFieldsValue({ [key]: result });
        this.OCRColorIcon[key] = "green";
      } else {
        this.OCRColorIcon[key] = "red";
      }
    },
    suggestInvoiceId(options) {
      options = options.sort((opt) =>
        opt.defaults.id ? -1 * opt.defaults.id.length : 0
      );
      if (!this.form.getFieldValue("num_invoice") && options[0].defaults.id) {
        this.form.setFieldsValue({
          num_invoice: options[0].defaults.id,
        });
        this.OCRColorIcon.num_invoice = "green";
        return;
      }
      this.OCRColorIcon.num_invoice = "red";
    },
    handlerKwotaDelete(index) {
      this.kwotaVals.history.splice(index, 1);
      this.updateKwota();
    },
    handlerChangePaymentDateReal(dateMoment, dateString) {
      if (this.kwotaVals.paidPercent < 100) {
        if (dateString) {
          this.validatePaymentDateReal = "success";
        } else {
          this.validatePaymentDateReal = "error";
        }
      }
    },
    handlerKwotaAdd() {
      let kwotaVal = +this.form.getFieldValue("kwotaVal");

      if (!kwotaVal) return;
      let payment = kwotaVal.toFixed(2);
      let date = this.form.getFieldValue("PaymentDateReal")
        ? moment(this.form.getFieldValue("PaymentDateReal")).format(
            "YYYY-MM-DD"
          )
        : 0;

      if (date && this.document.Quota && this.document.Quota.Netto && payment) {
        this.kwotaVals.history.push({
          date,
          payment,
          user: this.profile.ID,
        });
        this.form.setFieldsValue({
          PaymentDateReal: "",
          kwotaVal: "",
        });
        this.validatePaymentDateReal = "default";
        this.kwotaHistoryVisible = true;
        this.updateKwota();
      } else if (!date) {
        this.validatePaymentDateReal = "error";
      }
    },
    updateKwota() {
      this.kwotaVals.sum = +this.document.Quota.Netto;
      this.kwotaVals.paidSum = +this.kwotaVals.history
        .reduce((accum, curr) => accum + +curr.payment, 0)
        .toFixed(2);
      this.kwotaVals.paidPercent = +(
        (this.kwotaVals.paidSum * 100.0) /
        this.kwotaVals.sum
      ).toFixed(2);
      if (isNaN(this.kwotaVals.paidPercent)) this.kwotaVals.paidPercent = 0;
      this.kwotaVals.leftToPay = +(
        this.kwotaVals.sum - this.kwotaVals.paidSum
      ).toFixed(2);
      this.kwotaVals.leftToPayPercent = +(
        100.0 - this.kwotaVals.paidPercent
      ).toFixed(2);
    },
    handlerInvoiceType(e) {
      this.selectInvoiceCorrection = "";
      var kontragent =
        this.form.getFieldValue("kontragent") || this.document.kontragent;
      var my_company =
        this.form.getFieldValue("my_company") || this.document.my_company;
      if (
        my_company &&
        kontragent &&
        ["Korygujaca", "Faktura koncowa", "VAT Marza"].includes(e)
      ) {
        let types = {
          Korygujaca: "Correction",
          "Faktura koncowa": "Prepayment",
          "VAT Marza": "VatDiff",
        };
        getInvoiceCorrection({
          type: types[e],
          current_id: this.form.ID,
          my_company,
          kontragent,
        }).always((res) => {
          let data = JSON.parse(res);
          this.invoiceCorrectionVaribl = data;
          this.selectInvoiceCorrection = types[e];
        });
      }
    },
    handlerInvoiceCorrection(e) {
      let tables = this.invoiceCorrectionVaribl[e].invoiceTable;
      for (let table in tables) {
        for (let item in tables[table].sum_distribution) {
          if (tables[table].sum_distribution[item]["accept"]) {
            tables[table].sum_distribution[item]["accept"].status = false;
          }
        }
      }
      this.document.invoiceTable = tables;
      this.document.Quota = this.invoiceCorrectionVaribl[e].Quota;
    },
    handleDateChange(date, key) {
      let code = this.form.getFieldValue(key + "Code");
      if (date) {
        date = moment(date).subtract(1, "days");
        this[key + "Date"] =
          date.isoWeekday() > 5
            ? date.subtract(date.isoWeekday() - 5, "days").format("YYYY-MM-DD")
            : date.format("YYYY-MM-DD");
        if (code != "PLN") {
          getCurrency({ code, date: this[key + "Date"] }).done((data) => {
            let res = JSON.parse(data);
            if (res) {
              if (res.currency) {
                let kk = {};
                kk[key + "Val"] = res.rates[0]["mid"];
                this.form.setFieldsValue(kk);
                this.$message.success(this.$t("Currency updated"));
              }
            }
          });
        }
      }
    },
    handlerChangeContractor(e) {
      if (this.user_setup.BankAccount && e) {
        let comp = this.document.arrayCompany.find((x) => x.ID == e);
        this.bankAccountList = comp[this.user_setup.BankAccount] || [];
      } else {
        this.bankAccountList = [];
      }
      this.form.setFieldsValue({
        bankAccount: this.bankAccountList[0],
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    },
    handleCurrencyCodeChange(e, key) {
      var curr = this.info.currency.find((x) => x.CURRENCY == e);
      if (curr) {
        var kk = {};
        if (!this[key + "Date"] || curr.CURRENCY == "PLN") {
          kk[key + "Val"] = curr.AMOUNT;
          this.form.setFieldsValue(kk);
        } else {
          kk[key + "Code"] = curr.CURRENCY;
          this.form.setFieldsValue(kk);
          let curDate = "";
          if (key == "currency") {
            curDate = this.form.getFieldValue("saleDate");
          } else {
            curDate = this.form.getFieldValue("PaymentDateReal");
          }
          this.handleDateChange(curDate, key);
        }
      }
    },
    addBankAccount() {
      let val = this.form.getFieldValue("bankAccount");
      let comp = this.form.getFieldValue("kontragent");
      if (val && comp && this.user_setup.BankAccount) {
        let companyBankAccount =
          this.COMPANY_LIST[comp][this.user_setup.BankAccount];

        if (!companyBankAccount) {
          companyBankAccount = [val];
        } else if (!companyBankAccount.includes(val)) {
          companyBankAccount.push(val);
        }
        let kk = {};
        kk[this.user_setup.BankAccount] = companyBankAccount;

        BX24.callMethod(
          "crm.company.update",
          {
            id: comp,
            fields: kk,
          },
          function (result) {
            if (result.error()) console.error(result.error());
            else {
              console.info(result.data());
            }
          }
        );
      }
    },
    submit(updateStatus) {
      this.document.invoiceTable = this.document.invoiceTable.filter(
        (row) => row.namefield && row.koszty && row.sum
      );
      for (let i in this.document.invoiceTable)
        this.document.invoiceTable[i].key = i;
      this.form.validateFields((err, values) => {
        if (updateStatus && err) {
          this.$message.error(this.$t("Error describing invoice"));
        } else {
          this.changeSpinning();
          values["updateStatus"] = updateStatus;
          var updateStatistic = false;

          requestStep(this.saveValues(values))
            .done((data) => {

              let res = false;
              try {
                 res = JSON.parse(data);
              } catch (error) {
                console.error({error})
              }
                              
                if(res){
                  if (res.state == "errorNum" || res.state == "errorTable") {
                    if (res.state == "errorNum") {
                      this.$notification["error"]({
                        message: "Błąd",
                        description: this.$t(
                          "Prawdopodobnie dokument już istnieje - sprawdź przed wprowadzeniem."
                        ),
                      });
                      this.$notification["error"]({
                        message: "Błąd",
                        description: this.$t(
                          "Prawdopodobnie dokument już istnieje - sprawdź przed wprowadzeniem."
                        ),
                        placement: "bottomRight",
                      });
                    } else if (res.state == "errorTable") {
                      this.$notification["error"]({
                        message: "Błąd",
                        description: this.$t(
                          "To proceed to the next stage, fill in the required fields and the table."
                        ),
                      });
                      this.$notification["error"]({
                        message: "Błąd",
                        description: this.$t(
                          "To proceed to the next stage, fill in the required fields and the table."
                        ),
                        placement: "bottomRight",
                      });
                    }
                  } else {
                    if (this.document.status != res.status)
                      updateStatistic = {
                        prev: this.document.status,
                        next: res.status,
                      };
                    this.document.status = res.status;
                    this.document.invoiceTitle = res.data.invoiceTitle;
                    this.document.invoiceAutoNumber = res.data.invoiceAutoNumber;
                    this.document.title =
                      values.title != undefined
                        ? values.title
                        : this.document.title;
                    if (res.name) {
                      this.document.NAME = res.name;
                    }
                    this.$message.success(this.$t("Invoice description Saved"));
                  }
                }
                          

            })
            .fail((e) => {
              console.err(e);
              this.$message.error(this.$t("Error describing invoice"));
            })
            .always((data) => {

                let res = false;
                try {
                  res = JSON.parse(data);
                } catch (error) {
                  console.error({error})
                }

              this.changeSpinning();
              if (res && res.state != "error") {
                this.onback(updateStatus, updateStatistic);
              }
            });
        }
      });
    },
    saveValues(values) {
      var format_moment = (date) =>
        date ? moment(date).format("YYYY-MM-DD") : "";
      var data = {};
      data.currencyDate = this.currencyDate;
      data.invoiceCorrection =
        values.invoiceCorrection > -1
          ? this.invoiceCorrectionVaribl[values.invoiceCorrection].ID
          : "";
      data.num_invoice = values.num_invoice;
      data.Teczka = values.Teczka;
      data.key_words = values.key_words;
      data.kontragent = values.kontragent;
      data.document_type = this.document.document_type;
      data.proj_assist = this.responsible || "";
      data.bankAccount = values.bankAccount;
      data.invoiceType = values.invoiceType;
      data.kwota = this.kwotaVals;
      data.my_company = this.myCompany
        ? this.myCompany
        : this.document.my_company;
      data.kontragent = this.contractor
        ? this.contractor
        : this.document.kontragent;
      data.saleDate = format_moment(values.saleDate);
      data.plannedDate = format_moment(values.plannedDate);
      data.reminderDate = format_moment(values.reminderDate);
      data.date_recept = format_moment(values.date_recept);
      data.date_send = format_moment(values.date_send);
      data.paymentDate = format_moment(values.paymentDate);
      data.PaymentDateReal = format_moment(values.PaymentDateReal);

      for (let key in data) {
        if (
          key in this.document &&
          JSON.stringify(data[key]) != JSON.stringify(this.document[key])
        ) {
          data[key] = {
            old: this.document[key],
            new: data[key],
          };
        }
      }

      data.run = "saveinvoicestage1";
      data.ID = this.document.ID;
      data.updateStatus = values.updateStatus;
      data.invoiceTable = this.document.invoiceTable;
      data.elemid = this.document.mainid;
      data.Quota = this.document.Quota;
      data.payment = {
        type: values.paymentType,
        date: format_moment(values.paymentDate),
      };
      data.currency = {
        code: values.currencyCode,
        val: values.currencyVal,
      };
      for (let subkey of ["payment", "currency", "Quota"]) {
        if (
          JSON.stringify(data[subkey]) != JSON.stringify(this.document[subkey])
        ) {
          data[subkey] = {
            old: this.document[subkey],
            new: data[subkey],
          };
        }
      }
      return data;
    },
    checkChanged() {
      var kk = false;
      //FIXME раскоментить после работ!
      this.form.validateFields((err, values) => {
        for (let field of Object.entries(this.saveValues(values))) {
          if (
            typeof field[1] == "object" &&
            Object.keys(field[1]).includes("old")
          ) {
            kk = true;
            break;
          }
        }
      });
      return kk;
    },
    onback(updateStatus, updateStatistic) {
      this.$emit("onback", {
        visible_doc: true,
        unshift_elem: true,
        remove_elem: this.document.ID,
        updateStatistic,
        updateStatus,
      });
    },
    preview() {
      var invCorrec = this.form.getFieldValue("invoiceCorrection");
      if (invCorrec >= 0) {
        this.$emit("showPreview", this.invoiceCorrectionVaribl[invCorrec]);
      }
    },
    changeSpinning() {
      this.$emit("changeSpinning");
    },
  },
  mounted() {
    this.contractor = this.document.kontragent;
    this.contactorTitle = this.getCompany(this.document.kontragent);
    this.myCompany = this.document.my_company;
    this.myCompanyTitle = this.getCompany(this.document.my_company);
    this.handlerChangeContractor(this.document.kontragent);
    if (!this.document.kwota || !this.document.kwota.history)
      this.document.kwota = {
        leftToPayPercent: 0,
        leftToPay: 0,
        paidPercent: 0,
        paidSum: 0,
        sum: 0,
        history: [],
      };
    this.kwotaVals = Object.assign({}, this.kwotaVals, this.document.kwota);
    // console.log(this.kwotaVals, "kwotavals");
    // console.log(this.USER_LIST, "USER");
    if (this.document.Quota && this.document.Quota.Netto) this.updateKwota();
    let kk = this.invoiceCorrectionVaribl.findIndex(
      (x) => x.ID == this.document.invoiceCorrection
    );
    if (kk != -1) {
      this.form.setFieldsValue("invoiceCorrection", kk);
    }

    this.handlerInvoiceType(this.document.invoiceType);

    BX24.fitWindow();
  },
};
</script>
